import {ReportingPeriodEnum} from 'common/proxies/enum-proxy';
import BlockSelectBaseView from 'common/views/block-select-base-view';

const ComparisonSelectView = BlockSelectBaseView.extend({
  initialize(options) {
    this.$options = $('#comparisonOptions');
    this.$selected = $('#selectedComparison');
    this.getLabel = (period) => {
      return period.displayName.toLowerCase();
    };
    this.getPeriod = (label) => {
      switch (label) {
        case 'yesterday':
          return ReportingPeriodEnum.YESTERDAY;
        case 'last week':
          return ReportingPeriodEnum.LAST_WEEK;
        case 'last month':
          return ReportingPeriodEnum.LAST_MONTH;
        case 'last year':
          return ReportingPeriodEnum.LAST_YEAR;
        case 'none':
          return ReportingPeriodEnum.NONE;
        default:
      }
    };
    this.getPeriods = () => {
      const periods = [ReportingPeriodEnum.NONE];
      switch (this.mainPeriod.slug) {
        case ReportingPeriodEnum.TODAY.slug:
          periods.push(ReportingPeriodEnum.YESTERDAY);
          break;
        case ReportingPeriodEnum.WEEK.slug:
          periods.push(ReportingPeriodEnum.LAST_WEEK);
          break;
        case ReportingPeriodEnum.MONTH.slug:
          periods.push(ReportingPeriodEnum.LAST_MONTH);
          break;
        case ReportingPeriodEnum.YEAR.slug:
          periods.push(ReportingPeriodEnum.LAST_YEAR);
          break;
        default:
          // Do nothing
          break;
      }
      return periods;
    };

    let comparison;
    const configuration = options.settings.configuration;
    if (configuration && configuration.hasOwnProperty('comparison')) {
      comparison = configuration.comparison;
    }
    if (comparison) {
      this.selectedItem = comparison - 1;
    }

    if (configuration && configuration.hasOwnProperty('comparison_select')) {
      const comparisonSelect = configuration.comparison_select;
      if (comparisonSelect === 1) {
        this.lock();
      }
    }
  },

  setMainPeriod(period) {
    this.mainPeriod = period;
    this.periods = this.getPeriods();
    const current = this.getSelectedItem();
    if (current && current.slug !== ReportingPeriodEnum.NONE.slug) {
      this.selectedItem = this.periods[1];
    } else {
      this.selectedItem = this.periods[0];
    }
    this.appendOptions(this.selectedItem);
    this.setSelectedText(this.selectedItem.displayName);
  },
});

export default ComparisonSelectView;
